/**
 * Regras de limite das grades próprias (Mensal, Trimestral, Semestral, Anual).
 *
 * A comparação é feita pelo INÍCIO de cada período: agosto só é bloqueado se o
 * limite cair antes de 01/08, de modo que o período corrente permaneça
 * selecionável mesmo com o limite no meio dele.
 *
 * Diária e Período não passam por aqui — o ngx-bootstrap aplica `maxDate`
 * diretamente.
 */

function isAfterMax(periodStart: Date, maxDate: Date | null): boolean {
  if (!maxDate) {
    return false;
  }
  return periodStart > maxDate;
}

export function isMonthAfterMax(
  month: number,
  year: number,
  maxDate: Date | null
): boolean {
  return isAfterMax(new Date(year, month - 1, 1), maxDate);
}

export function isQuarterAfterMax(
  quarter: number,
  year: number,
  maxDate: Date | null
): boolean {
  return isAfterMax(new Date(year, (quarter - 1) * 3, 1), maxDate);
}

export function isSemesterAfterMax(
  semester: number,
  year: number,
  maxDate: Date | null
): boolean {
  return isAfterMax(new Date(year, (semester - 1) * 6, 1), maxDate);
}

export function isYearAfterMax(year: number, maxDate: Date | null): boolean {
  return isAfterMax(new Date(year, 0, 1), maxDate);
}
